import { render, staticRenderFns } from "./package.vue?vue&type=template&id=7e4eb522&scoped=true&"
var script = {}
import style0 from "./package.vue?vue&type=style&index=0&id=7e4eb522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4eb522",
  null
  
)

export default component.exports